import requestAnimationFrame from 'requestanimationframe';
import {FadeIn} from '../Theme/FadeIn';
import {ScrollTop} from '../Theme/ScrollTop';

export default class {

    constructor() {
        this.resize();
    }

    resize() {
        let calculate,
            tick,
            ticking = false;

        calculate = function() {
            new FadeIn();
            new ScrollTop();
            ticking = false;
        };

        tick = function() {
            if (!ticking) {
                requestAnimationFrame(calculate);
                ticking = true;
            }
        };
        tick();

        $(window).on('scroll', function() {
            tick();
        });
    }
}



// WEBPACK FOOTER //
// ./src/Frontend/Themes/Custom/src/Js/Utilities/Scroll.js